import { Card } from "@/components/ui/card"

type Props = {
	title: string
	fields: React.ReactNode[]
	description?: string
}

const Section = ({ title, fields, description }: Props) => {
	return (
		<div className="mb-1">
			<div className="mb-4 flex flex-col items-start justify-center space-y-1">
				<h2 className="text-sm font-medium">{title}</h2>
				{description && (
					<p className="text-muted-foreground text-xs">
						{description}
					</p>
				)}
			</div>
			<Card className="grid grid-cols-1 gap-4 border-2 px-5 py-6 sm:grid-cols-2">
				{fields}
			</Card>
		</div>
	)
}

export default Section
